module.exports = __webpack_public_path__ + "img/3-4.fd161b19.svg";